import classes from './TeamManagementPage.module.css'

function CommandInfo({ command }) {
    if (!command?.id) {
        console.warn('⚠️ [CommandInfo] Команда не передана или нет id')
        return null
    }

    return (
        <li>
            <div className={classes.infoSection}>
                <h3 className={classes.infoTitle}>Информация о команде</h3>
                <div className={classes.infoGrid}>
                    <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Название:</span>
                        <span className={classes.infoValue}>{command.name}</span>
                    </div>
                    <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Стол №:</span>
                        <span className={classes.infoValue}>{command.table_number || 'Не указан'}</span>
                    </div>
                    <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Мероприятие:</span>
                        <span className={classes.infoValue}>{command.occasion_name}</span>
                    </div>
                </div>
            </div>
        </li>
    )
}

export default CommandInfo

